export enum EventHubLogStatus {
	Pending = 1,
	Closed = 2,
	Invalid = 3,
}
